// @ts-check
import React, { Component } from "react"
import AvailableBroadcast from "../broadcast/AvailableBroadcast"

/**
 * @augments {Component<{children: (props: Broadcast_Property[]) => any}>}
 */
class AvailableProperties extends Component {
    /**
     *
     * @param {Broadcastable[]} broadcast
     * @return {Broadcast_Property[]}
     */
    getProperties = broadcast => {
        /**
         *  @type {Broadcast_Property[]}
         */
        // @ts-ignore
        const result = broadcast.filter(({ channel }) => channel === "property")

        return result
    }
    render() {
        return (
            <AvailableBroadcast>
                {broadcast => this.props.children(this.getProperties(broadcast))}
            </AvailableBroadcast>
        )
    }
}

export default AvailableProperties



// WEBPACK FOOTER //
// ./src/features/editor/properties/AvailableProperties.js